export default {
    watch:{
        isValid:{
            immediate: true,
            handler(value){
                this.$storage.state.isValid = this.isValid;
            }
        }
    }
}
